import React, { useEffect } from "react";

import { useState,useContext } from "react";
import { useUrlContext } from '../context/urlContext';
import { useAuth } from '../context/authContext';

import ParentComponent from "../Components/ParentForTableAndFormComponent";
import axios from "axios";
import PromotionForm from "../Forms/PromotionForm";

import { errorContext } from "../Components/ErrorDisplay"
import { useConfirm } from "../Components/ConfirmDialog";

function Promotion(props) {
    
    const { UrlHelperObj } = useUrlContext();
        const { logout, user } = useAuth();
    const {handleError,setLoading,setErrorMessage} = useContext(errorContext);
    const confirm = useConfirm();
    const [columnInfo, setColumnInfo] = useState([
        {  title: 'Name',dbname:'name' },
        {  title: 'Promotion Type',dbname:'typeStr' },
        {  title: 'Status',dbname:'status_display' },
        // {title:'Brand Name',dbname:'brand_name'},
        // {title:'Description',dbname:'description'},
    //    {title:'Launch Date/Time',dbname:'launch_date_time'},
       {title:'Valid From Date',dbname:'valid_from'},
       {title:'Valid To Date',dbname:'valid_to'},
       {title:'Valid From Time',dbname:'valid_from_time_str'},
       {title:'Valid To Time',dbname:'valid_to_time_str'},
    //    {title:'Valid From Time',dbname:'valid_from_time'},
    //    {title:'Valid To Time',dbname:'valid_to_time'},
    //    {title:'Total Quantity',dbname:'total_qty'},
       {title:'Scans allowed',dbname:'num_scans_allowed'},
       {title:'Days allowed',dbname:'num_days_allowed'},
       //{title:'Program',dbname:'programid[name]'}
    //    {title:'Promotion Text',dbname:'promotion_text'},
    //    {title:'Instructions',dbname:'instructions'},
/*     {title:'Promotion Type',dbname:'typeStr'},
       {title:'Promotion Image',dbname:'image'},
       {title:'Program',dbname:'programid_name'},
       {title:'Tier',dbname:'tierid_name'} */
    ]);
    const[selectedBrand,setSelectedBrand] = useState(null);
    const[promotionRecords,setPromotionRecords]=useState([]);
    const[isSubmittingPromotion,setIsSubmittingPromotion] = useState(false);
    
    
    
    useEffect(()=>{
        if(!user?.issuerId){
            setErrorMessage("Missing issuer information. Please login again.");
            return;
        }

        setLoading(true);
        getPromotionRecords();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[user?.issuerId]);

    // function toLocalTimeZone(utcDate,utcTime)
    // {
        
    //     const newDate = utcDate+"T"+utcTime;
    //     const d = new Date(newDate);
    //     //var lDate = d.toLocaleDateString();
    //     //var lTime = d.toLocaleTimeString();
    //     return d;//.toLocaleString();
    // }
    function tenFunc(i){
        return(i<10?'0':'')+i;
    }
    function toLocalDate(utcDate,utcTime)
    {
        if(utcDate === null)
            return "";
        const newDate = utcDate+" "+utcTime+"  UTC";
        const d = new Date(newDate);
        var monStr = tenFunc(d.getMonth()+1);
        //var localDateStr = tenFunc(d.getDate())+"/"+monStr +"/"+d.getFullYear();
        var localDateStr =d.getFullYear()+"-"+monStr+"-"+tenFunc(d.getDate());
                        
        
        var lDate = d.toLocaleDateString();
        var lTime = d.toLocaleTimeString();
        return localDateStr;
    }
    // function getLocalDateTime(utcDate,utcTime)
    // {
    //     const newDate = utcDate+" "+utcTime+"  UTC";
    //     return(new Date(newDate));
    // }
    function toLocalTime(utcDate,utcTime)
    {
        if(utcDate === null)
        {
            console.log("utc date is null");

            var tDate = new Date();
            utcDate = tDate.toLocaleDateString();
            console.log("using current date as utc date:"+utcDate);
        }
        else console.log("utc date is "+utcDate);
            
        const newDate = utcDate+" "+utcTime+"  UTC";
        console.log("newDate is "+newDate);
        const d = new Date(newDate);
        console.log("local date is "+d.toLocaleDateString());
        var t = d.toLocaleTimeString();
        console.log("local time is "+t);
        var t1 = t.substring(t.lastIndexOf(' ')+1);
        console.log("AM/PM is "+t1);
        // for 12 hour time
        //var t2 = tenFunc(d.getHours())+":"+tenFunc(d.getMinutes())+" "+t1;

        // for 24 hour time
        var t2 = tenFunc(d.getHours())+":"+tenFunc(d.getMinutes());
        console.log("local final time is "+t2);
        return t2;
        
    }
    function updatePromotionResults(results)
    {
        if(results.length === 0)
        {
            setErrorMessage("No records found.");
        }
        
        results.forEach((values,key)=>{
          /*
            var timet = toLocalTime(values.valid_from,values.valid_from_time)
            var timet1 = toLocalTime(values.valid_to,values.valid_to_time)
        
            var fromDate = toLocalDate(values.valid_from,values.valid_from_time);
            var toDate = toLocalDate(values.valid_to,values.valid_to_time);
            */
            values.valid_from_time_str = values.valid_from_time; //timet;
            values.valid_to_time_str = values.valid_to_time; //timet1;
            values.valid_from_date_str = values.valid_from; //fromDate;
            values.valid_to_date_str = values.valid_to; //toDate;
            
//           values.valid_from_time = getLocalDateTime(values.valid_from,values.valid_from_time);
//            values.valid_to_time = getLocalDateTime(values.valid_to,values.valid_to_time);
          
          var typeStr="";
          switch(Number(values.type)){
            case 0:
                typeStr="Membership";
                break;
            case 1:
                typeStr="Public promotion";
                break;
            case 2:
                typeStr="Member offer";
                break;
            default:
                typeStr="";
                break;
          }
          values.typeStr = typeStr;

          // Server sends status as "active" / "expired" / "not current".
          values.status_display = values.status
            ? values.status.charAt(0).toUpperCase() + values.status.slice(1)
            : '';

                    // Normalize assignment flag/count from possible backend field names.
                    const assignedValue = values.assigned
                        ?? values.is_assigned
                        ?? values.assigned_count
                        ?? values.assignment_count
                        ?? values.assignedCount
                        ?? values.Assigned;
                    values.assigned = Number(assignedValue);
        })
        
        setPromotionRecords(results);
        //props.setLoading(false);
        console.log("SET-LOAD-false");
       setLoading(false);
    }
   /* function handleError(err)
    {
        setLoading(false);
        if(err.response)
        {
            console.log(err.response);
            setErrorMessage(err.response.data.message);
        }
        else if(err.request)
        {
            console.log(err.request);
        }
    }*/
    
    async function getPromotionRecords()
    {
        if(!user?.issuerId){
            setErrorMessage("Missing issuer information. Please login again.");
            setLoading(false);
            return;
        }

        console.log('Fetching promotion list (GET) for issuer id', user.issuerId);
        try {
            const response = await axios.get(UrlHelperObj.promotionUrlByStatus(user.issuerId, 0));
            const results = response.data;
            updatePromotionResults(Array.isArray(results) ? results : []);
        } catch (err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    }
    async function deletePromotionRecord(record)
    {
        const shouldDelete = await confirm({ title: 'Delete promotion', message: 'Delete this promotion?', confirmText: 'Delete' });
        if(!shouldDelete)
            return;

        setLoading(true)
        await axios.delete(UrlHelperObj.promotionUrlById(record))
        .then(response => response.data)
        .then(results =>console.log("delete of Partner "+record+" successful"))
        .catch(err => handleError(err));
        setLoading(false);
        getPromotionRecords();
    }
    async function editPromotionRecord(record)
    {
        if (!user?.issuerId) {
            setErrorMessage("Missing issuer information. Please login again.");
            return;
        }
        if (isSubmittingPromotion) {
            console.warn('Duplicate editPromotionRecord ignored because a promotion operation is in progress');
            return;
        }
        setIsSubmittingPromotion(true);
        setLoading(true);
        const data = {
            id: record.id,
            name: record.name,
            issuer_id: user.issuerId,
            description: record.description,
            instructions: record.instructions,
            valid_to: record.valid_to,
            valid_from: record.valid_from,
            valid_from_time: record.valid_from_time,
            valid_to_time: record.valid_to_time,
            num_days_allowed: record.num_days_allowed,
            num_scans_allowed: record.num_scans_allowed,
            promotion_text: record.promotion_text,
            type: record.type,
            programid: record.programid,
            scans_per_day: record.scans_per_day,
            valid_days: record.valid_days
};
        //data.append("timezone",Intl.DateTimeFormat().resolvedOptions().timeZone);
        
        try {
            const response = await axios.put(
                UrlHelperObj.promotionUrl(),
                data,
                { headers: { 'Content-Type': 'application/json' } }
            );
            // Server may reject with 2xx + { error:1, message } (e.g. bad/unconfigured
            // template id). The global interceptor already toasts the message; reject
            // (without re-toasting) so the form stays open for the user to fix.
            if (response?.data && (response.data.error === 1 || response.data.error === true)) {
                return Promise.reject(new Error(response.data.message || 'Promotion was not saved.'));
            }
            console.log('Edit of Partner successful', response.data);
            getPromotionRecords();
        } catch (err) {
            handleError(err);
            throw err;
        } finally {
            setIsSubmittingPromotion(false);
            setLoading(false);
        }
    }
    async function addPromotionRecord(record)
    {
        if (!user?.issuerId) {
            setErrorMessage("Missing issuer information. Please login again.");
            return;
        }
        if (!record) {
            console.error('addPromotionRecord called with null record');
            return;
        }
        if (isSubmittingPromotion) {
            console.warn('Duplicate addPromotionRecord ignored because a promotion add is already in progress');
            return;
        }

        setIsSubmittingPromotion(true);
        setLoading(true);

        const brandId = record.brand_id || selectedBrand?.id || props.BrandRow?.id || props.BrandRow?.brand_id;
        if (!brandId) {
            console.warn('addPromotionRecord has no brand_id; request will still be sent', record);
        }
        console.log('addPromotionRecord starting', { record, brandId });
        const data = {
            id: 0,
            name: record.name,
            issuer_id: user.issuerId,
            brand_id: brandId || 0,
            description: record.description,
            instructions: record.instructions,
            valid_to: record.valid_to,
            valid_from: record.valid_from,
            valid_from_time: record.valid_from_time,
            valid_to_time: record.valid_to_time,
            num_days_allowed: record.num_days_allowed,
            num_scans_allowed: record.num_scans_allowed,
            promotion_text: record.promotion_text,
            type: record.type,
            programid: record.programid,
            scans_per_day: record.scans_per_day,
            valid_days: record.valid_days
        };

        try {
            const response = await axios.post(
                UrlHelperObj.promotionUrl(),
                data,
                { headers: { 'Content-Type': 'application/json' } }
            );
            // Server may reject with 2xx + { error:1, message } (e.g. bad/unconfigured
            // template id). The global interceptor already toasts the message; reject
            // (without re-toasting) so the form stays open for the user to fix.
            if (response?.data && (response.data.error === 1 || response.data.error === true)) {
                return Promise.reject(new Error(response.data.message || 'Promotion was not saved.'));
            }
            console.log('Add of Partner successful', response.data);
            getPromotionRecords();
        } catch (err) {
            handleError(err);
            throw err;
        } finally {
            setIsSubmittingPromotion(false);
            setLoading(false);
        }
    }

    function handleFormSubmit(data,isAddOperation,isCancelOperation)
    {
        if(isCancelOperation === true)
        {
            console.log("Cancelled operation");
            return 0;
        }
        if (isSubmittingPromotion) {
            console.warn('handleFormSubmit ignored because a promotion add/edit is already in progress');
            return;
        }
        console.log("handleFormSubmit", data, "add-operation", isAddOperation);
        // Return the add/edit promise so ParentComponent waits for the server response
        // before switching to the table (stays on the form if it fails).
        return isAddOperation ? addPromotionRecord(data) : editPromotionRecord(data);
    }
    
    
    return(
        <div style={{ width: '100%' }}>
            <ParentComponent 
            data={promotionRecords}
            columns={columnInfo}
            form={PromotionForm}
            formTitle={"Promotion"}
            hideFormTitle={true}
            handleFormSubmitFunc={handleFormSubmit}
            setFormShownFlag={props.setFormShown}
            alreadySelectedOwnRow={props.alreadySelectedOwnRow}
            deleteFunc={deletePromotionRecord}
            setSelectedRow={props.setSelectedRow}
            selectedBrandRow={props.BrandRow}
            isAddDisabled={false}
            />
        </div>
    );
            
}
export default Promotion;
